export enum TransactionItemFilterStatuses {
    ALL = 0,
    UNMATCHED = 1,
    PARTIALLY_MATCHED = 2,
    MATCHED = 3,
    AUTOMATICALLY_MATCHED = 4,
    DELETED = 5,
    IGNORED = 6
}
